import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  background-color: #ffffff;
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin: 0 auto;
  width: 100%;
  flex: 1;
  overflow-y: auto;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  max-width: 1280px;
  width: 100%;
  flex: 1;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 800px;
`;

export const Titulo = styled.h1`
  font-family: "Inter", sans-serif;
  font-weight: bold;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  text-align: center;
`;

export const Subtitulo = styled.h2`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 1.1rem;
  margin-top: 2rem;
  text-align: left;
`;

export const Item = styled.p`
  font-family: "Inter", sans-serif;
  margin: 0.5rem 0;
  font-size: 0.9rem;
  line-height: 1.6;
  text-align: left;
`;

export const ItemWithIndent = styled.p<{ level?: number }>`
  font-family: "Inter", sans-serif;
  margin: 1rem 0;
  font-size: 0.9rem;
  line-height: 1.6;
  text-align: left;
  margin-left: ${({ level = 0 }) => level * 20}px;
`;
